import type { Media } from '../tanstack-query/get/medias/get-blob';

export type MediaPreviewType = 'pdf' | 'video' | 'image' | 'spreadsheet';

export const defineMediaPreviewType = (mimetype: Media['mimetype']): MediaPreviewType => {
	const isVideo = mimetype?.includes('video/');
	const isImage = mimetype?.includes('image/');
	const isPdf = mimetype?.includes('application/pdf');
	const isSpreadsheet = mimetype?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

	if (isVideo) return 'video';
	if (isImage) return 'image';
	if (isPdf) return 'pdf';
	if (isSpreadsheet) return 'spreadsheet';
	return 'image';
};
